import React, { useCallback, useEffect, useRef, useState } from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import { navigate } from "vike/client/router"
import MenuGroup from "aldoo-ra/MenuGroup"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import useSigninController from "aldoo-ra/Signin/signin-controller"
import { useSearchParamValue } from "aldoo-ra/SearchParams"
import TopRightPageBlueBg from "./TopRightPageBlueBg"

//tabs
import Subscriptions from "./Subscriptions"
import Profile from "./Profile"
import Activate from "./Activate"
import Devices from "./Devices"

//map section to tab
const tabs = {
  subscriptions: Subscriptions,
  profile: Profile,
  activate: Activate,
  devices: Devices,
}

const AccountPage = () => {
  const actionMap = useRef({})
  const { logout, userProfile } = useSigninController()

  //if there is no profile, go back to the home page
  useEffect(() => {
    if (!userProfile) navigate("/")
  }, [userProfile])

  //get the current url section
  const section = useSearchParamValue("section") || "profile"
  //what class should be applied to the selected menu item
  const selectedMenuItemClass = "font-bold text-primary"

  //update the action map with a key that resolves to navigate
  const updateActionMap = (key) => {
    if (!key) return
    const newMap = { ...actionMap.current }
    if (key == "logout") {
      newMap[key] = logout
    } else {
      newMap[key] = () => navigate(`/account?section=${key}`)
    }
    actionMap.current = newMap
  }

  //update the logout action reference
  useEffect(() => {
    updateActionMap("logout")
  }, [logout])

  const tab = tabs[section] || (() => <div>Not Found</div>)

  return (
    <CMSRender
      contentType="ProfilePage"
      onData={(data) => {
        const menu = data.data[0].content.menu[0].content.items
        menu.map((item) => updateActionMap(item.content.options?.action))
      }}
      renderItem={(page) => {
        const username = userProfile?.name || "User"
        const title = page.title.replace("{{username}}", username)

        return (
          <div className="relative min-h-screen w-full bg-gradient_account">
            <div className="min-h-screen w-full max-w-w2_xl px-4 mx-auto">
              {/* Header */}
              <div className="w-full h-[156px] flex items-end justify-start border-b border-bordered pl-4 py-[30px]">
                <Typography variant="h2">{title}</Typography>
              </div>

              {/* Sidebar + Tab Content */}
              <div
                className="relative w-full flex pl-4 pt-[63px]"
                style={{ zIndex: 50 }}
              >
                {/* Left Sidebar Menu */}
                <div className="w-[240px]">
                  <MenuGroup
                    name={page.menu[0].name}
                    renderAs="vlist"
                    skipRootItem
                    actionMap={actionMap.current}
                    styleOverrides={{
                      menu_column: "hidden",
                      menu_item: "px-0 my-0",
                    }}
                    menuItemRender={(item) => {
                      return (
                        <Button
                          variant="nav_menuitem"
                          className="font-bold w-full h-[44px] flex items-center px-0 my-[18px]"
                        >
                          {item.image && (
                            <img
                              src={item.image}
                              alt=""
                              className="w-5 h-5 mr-3"
                            />
                          )}
                          <Typography
                            variant="btn1"
                            className={
                              section == item.options?.action
                                ? selectedMenuItemClass
                                : "text-gray_700 hover:text-text"
                            }
                          >
                            {item.label}
                          </Typography>
                        </Button>
                      )
                    }}
                  />
                </div>

                {/* Main Content Area */}
                <div className="w-full flex-1">
                  {/* Tab based on selected menu item */}
                  {tab()}
                </div>
              </div>
            </div>

            <TopRightPageBlueBg />
          </div>
        )
      }}
    />
  )
}

export default AccountPage
